import { useContext, useState} from 'react'
import {  Box, Grid, Flex } from 'theme-ui'
import { CanvasContext } from '../../hooks/LessonPage';
import {  Input,Typography,Button, Form } from 'antd';
import './UrlPanel.scss';

const { TextArea } = Input;
const { Title } = Typography;

function EmbedPanel() {
  const [form] = Form.useForm();
  const variant = Form.useWatch('variant', form);
  const [formLayout, setFormLayout] = useState('vertical');
  const { state, actions } = useContext(CanvasContext);


  const onFinish = (values) => {
    var data = {type : "EMBED", url : "", defaultcontent : values.embedHTML}
    actions?.addElement(data);  
  };

  return (
    <>
        <div style={{
            width: "100%",
            height: "50px",
            margin: "auto",
            justifyItems: "center",
            alignItems: "center",
            textAlign: "center",
            marginTop: "10px"      
             }}>
                <div style={{color : 'white' , fontWeight : 'bold', width : '100%', fontSize : '18px' }}>
                    Embed HTML
                </div>
        </div>      
      <Grid sx={{ gridTemplateRows: '50px 50px 50px' }}>
           <Box sx={{ fontWeight: 600, fontSize: '2rem', margin : "1rem 1rem" }}>
           <Form
              layout={formLayout}
              form={form}
              initialValues={{
                layout: formLayout,
              }}
              style={{
                maxWidth: formLayout === 'inline' ? 'none' : 600,
              }}   
              onFinish={onFinish}           
            >             
            <Form.Item
              label="Enter your Embedded HTML :"
              name="embedHTML"
              rules={[{  pattern: new RegExp(/(https):\/\/([\w.]+\/?)\S*/), required: true, message: 'Please enter a valid embed html here!' }]}
            >
              <Input.TextArea  
                style={{ height: 120, resize: 'none' }}              
               />
            </Form.Item>   

            <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>                  
         </Form>
         </Box>
      </Grid>
  
    </>
  )
}
export default EmbedPanel
